/**
 * Resolves the API server base URL.
 *
 * Lives in its own lib module (not inline in components) so the
 * `import.meta.env` read stays out of component files — components that read
 * import.meta directly can't be imported under ts-jest's CommonJS transform
 * (same pattern as reviewShareUrl.ts / devBuild.ts). Jest never evaluates
 * this file: jest.config.js maps every specifier of it to
 * src/test/__mocks__/apiBaseUrl.ts (guard: apiBaseUrl.jestLoad.test.ts).
 */
export function apiBaseUrl(): string {
  return import.meta.env.VITE_API_URL || 'https://api.overlayqa.com';
}
